import styled from 'styled-components';

import { CenterChildren } from 'styles/layouts';

import type { GridContainerProps, CellContainerProps } from './types';

/**
 * Returns column repeat sizes for the grid
 * If maxColumnValue is specified - calculate max width as a full width minus (maxColumnValue - 1) grid gaps
 * If maxColumnValue is not specified - leave 1 fraction to adjust items automatically
 */
const getGridTemplateColumns = ({
  maxColumnsCount,
  gap,
}: GridContainerProps) => {
  const maxColumnWidth = maxColumnsCount
    ? `calc(${100 / maxColumnsCount}% - ${gap} * ${
        (maxColumnsCount - 1) / maxColumnsCount
      })`
    : '1fr';
  return maxColumnWidth;
};

export const GridContainer = styled.div<GridContainerProps>`
  display: grid;
  grid-template-columns: repeat(auto-fit, ${getGridTemplateColumns});
  gap: ${({ gap }): string => gap};
  justify-content: center;
`;

export const EmptyGridContainer = styled(CenterChildren)`
  height: auto;
`;

export const CellContainer = styled.div<CellContainerProps>`
  width: 100%;
  min-width: ${({ minElementWidth }): string => minElementWidth};
`;
